import React from "react";
import AppRoutes from "./routes/AppRoutes";
import "@lib/i18n";

const App: React.FC = () => (
  <div className="min-h-screen bg-gray-100">
    <AppRoutes />
  </div>
);

export default App;
